"use client";
import { useEffect, useState } from "react";
import { initializeAnalytics, disableAnalytics } from "../analytics/ga";
import { setConsent, getConsent, hasConsentBeenSet } from "../analytics/consent";

export const cookieBannerRef = { current: null };

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!hasConsentBeenSet()) {
            setVisible(true);
        } else if (getConsent() === "accepted") {
            initializeAnalytics();
        }
    }, []);

    useEffect(() => {
        cookieBannerRef.current = () => {
            setVisible(true);
        };
        return () => {
            cookieBannerRef.current = null;
        };
    }, []);

    const acceptCookies = () => {
        setConsent("accepted");
        initializeAnalytics();
        setVisible(false);
    };

    const declineCookies = () => {
        disableAnalytics();
        setConsent("declined");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-left">
                <div className="cookie-icon">🍪</div>

                <div className="cookie-text">
                    <h3>Cookie-Einstellungen</h3>
                    <p>
                        Wir nutzen <strong>Google Analytics 4</strong>, um zu verstehen, wie
                        unsere Quiz-App genutzt wird (z.&nbsp;B. Start, Fortschritt,
                        Ergebnisse). Dabei werden folgende Daten erhoben: IP-Adresse
                        (anonymisiert), Gerätedaten, Seitenaufrufe und Interaktionen.
                    </p>
                    <p>
                        Die Daten werden an <strong>Google Ireland Ltd.</strong> übertragen
                        und können auf Servern in den <strong>USA</strong> verarbeitet werden
                        (Rechtsgrundlage: Standardvertragsklauseln gem. Art.&nbsp;46 DSGVO).
                        Analyse-Cookies werden für <strong>bis zu 2 Jahre</strong>{" "}
                        gespeichert (_ga‑Cookie).
                    </p>
                    <p style={{ fontSize: "0.8em", marginTop: "6px", opacity: 0.75 }}>
                        Sie können Ihre Einwilligung jederzeit über den 🍪-Button unten
                        rechts widerrufen.{" "}
                        <a
                            href="#impressum-datenschutz"
                            onClick={(e) => {
                                e.preventDefault();
                                const el = document.getElementById("impressum-datenschutz");
                                if (el) {
                                    el.setAttribute("open", "");
                                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                            style={{ color: "inherit", textDecoration: "underline" }}
                        >
                            Datenschutzerklärung
                        </a>
                    </p>
                </div>
            </div>

            <div className="cookie-buttons">
                <button className="cookie-btn cookie-decline" onClick={declineCookies}>
                    Ablehnen
                </button>
                <button className="cookie-btn cookie-accept" onClick={acceptCookies}>
                    Akzeptieren
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;